/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_JewelleryInputs */

const en_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jewellery`)
};

const es_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joyería`)
};

const fr_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bijoux`)
};

const de_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schmuck`)
};

const ja_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジュエリー`)
};

const zh_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`珠宝首饰`)
};

const ar_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجوهرات`)
};

const id_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perhiasan`)
};

const it_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioielli`)
};

const ru_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ювелирные изделия`)
};

const pt_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joias`)
};

const ko_listing_category_jewellery = /** @type {(inputs: Listing_Category_JewelleryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주얼리`)
};

/**
* | output |
* | --- |
* | "Jewellery" |
*
* @param {Listing_Category_JewelleryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_jewellery = /** @type {((inputs?: Listing_Category_JewelleryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_JewelleryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_jewellery(inputs)
	if (locale === "es") return es_listing_category_jewellery(inputs)
	if (locale === "fr") return fr_listing_category_jewellery(inputs)
	if (locale === "de") return de_listing_category_jewellery(inputs)
	if (locale === "ja") return ja_listing_category_jewellery(inputs)
	if (locale === "zh") return zh_listing_category_jewellery(inputs)
	if (locale === "ar") return ar_listing_category_jewellery(inputs)
	if (locale === "id") return id_listing_category_jewellery(inputs)
	if (locale === "it") return it_listing_category_jewellery(inputs)
	if (locale === "ru") return ru_listing_category_jewellery(inputs)
	if (locale === "pt") return pt_listing_category_jewellery(inputs)
	return ko_listing_category_jewellery(inputs)
});